import { storageKey } from '@/constant/storage'
import { getNewToken } from 'Apis/auth'
import { deleteCookie, setCookie } from 'Utils/cookie'
import { cookieKey } from '@/constant/cookie'

interface JwtPayload {
  exp: number
  iat: number
  aud: string
  iss: string
  sub: string
  auth_time: number
}

export const getAuthToken = (): string | null => {
  if (typeof window === 'undefined') return null
  if (!localStorage) return null
  const token = localStorage.getItem(storageKey.TOKEN)
  if (token && isJwtExpiringSoon(token)) {
    refreshToken().then()
  }
  return token
}

export const setAuthToken = (token: string): void => {
  if (!localStorage) return
  setCookie(cookieKey.AUTH_TOKEN, token, 30)
  return localStorage.setItem(storageKey.TOKEN, token)
}

export const removeAuthToken = (): void => {
  if (!localStorage) return
  deleteCookie(cookieKey.AUTH_TOKEN)
  return localStorage.removeItem(storageKey.TOKEN)
}

export const removeLegacyAuthToken = (): void => {
  if (!localStorage) return
  localStorage.removeItem(storageKey.TOKEN)
}

export const parseJwtPayload = (token: string): JwtPayload => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
  return JSON.parse(jsonPayload)
}

export const hasJwtNotExpired = (token: string): boolean => {
  try {
    const payload = parseJwtPayload(token)
    // 如果存在exp字段，检查token是否过期
    if (payload.exp) {
      const currentTime = Math.floor(Date.now() / 1000) // 获取当前时间的时间戳（秒）
      if (currentTime >= payload.exp) {
        return false
      }
    } else {
      // 如果不存在exp字段，返回false
      return false
    }

    return true
  } catch (e) {
    return false
  }
}

const isJwtExpiringSoon = (token: string): boolean => {
  try {
    const payload = parseJwtPayload(token)
    // 如果存在exp字段，检查token是否过期
    if (payload.exp) {
      const currentTime = Math.floor(Date.now() / 1000) // 获取当前时间的时间戳（秒）
      if (payload.exp - currentTime > 0 && payload.exp - currentTime < 60 * 5) {
        return true
      }
    }

    return false
  } catch (e) {
    return false
  }
}

let refreshing = false
const refreshToken = async () => {
  if (refreshing) return
  refreshing = true
  try {
    const token = await getNewToken()
    if (!token) {
      throw new Error('No refresh token data')
    }
    setAuthToken(token)
  } catch (e) {
    console.error('Failed to refresh token:', e)
    removeAuthToken()
  } finally {
    refreshing = false
  }
}
